import PromptPreview from "./PromptPreview";
import React, { useState } from "react";
import { Form, FormGroup, Button, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { axiosOpen } from "../../api/axios";
import { getUserID } from "../../service";
import { toast, Toaster } from "react-hot-toast";

function Prompt() {
  const userID = getUserID();
  const [isLoading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const { register, handleSubmit, reset } = useForm();
  const [apiError, setApiError] = useState({ msg: "", status: false });
  const onSubmit = async (data) => {
    const formData = {
      description: data?.jobDescription,
    };
    setLoading(true);
    try {
      const response = await axiosOpen.post(`api/prompt/getprompt/${userID}`, formData);
      let result = response.data.message;
      if (result[0] === "\n") {
        result = result.slice(1);
      }
      setResponseData(result);
      setLoading(false);
      reset();
    } catch ({ response }) {
      toast.error(response.data.msg);
      setLoading(false);
      reset();
    }
  };
  return (
    <>
      <div className="prompt-container h-100">
        {responseData === null ? (
          <div className="prompt-form">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <FormGroup className="mb-2">
                <Form.Label>Ask Anything*</Form.Label>
                <Form.Control {...register("jobDescription", { required: true })} as="textarea" placeholder="Describe your prompt here..." rows={5} />
              </FormGroup>
              {isLoading ? (
                <Spinner className="text-center" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              ) : (
                <Button className="mt-4" variant="success" type="submit">
                  Submit
                </Button>
              )}
            </Form>
          </div>
        ) : (
            <PromptPreview responseData={responseData} />
        )}
      </div>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </>
  );
}

export default Prompt;
